// ***NOTE*** Please preserve alphabetical order when adding new icons
export {
  faArrowsH as faArrowsHLight,
  faCalendarAlt as faCalendarLight,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronLeft as faChevronLeftLight,
  faChevronRight as faChevronRightLight,
  faEllipsisV,
  faExclamationCircle as faExclamationCircleLight,
  faHome as faHomeLight,
  faKey as faKeyLight,
  faLink as faLinkLight,
  faPlus as faPlusLight,
  faQuestionCircle as faQuestionCircleLight,
  faTimes,
  faTrash,
  faUser as faUserLight,
  faUserSlash as faUserSlashLight,
  faUserTag as faUserTagLight,
} from '@fortawesome/pro-light-svg-icons'
